import Button from './Button'
import Paginate from './Paginate'

Paginate.Button = Button

export default Paginate



// WEBPACK FOOTER //
// ./src/components/Paginate/index.js